import {initPollChart} from "./custom/init-poll-chart";

$(() => {
    initPollChart();
})